module.exports = __webpack_public_path__ + "img/bg02.ecc337f8.png";